import styled from 'styled-components'

export const PentagonBg = styled.div`

    background-image: url(${props => props.image});
    background-position: left top;
    background-repeat: no-repeat;
    background-color: #fff;
    color: #141f2f;
    font-family: 'Inter', sans-serif;
    display:block;
    /* padding-bottom: 81px; */
    height: 290px;
    padding-top: 48px;
    line-height: 24px;

    @media (max-width: 950px) {
        height: 350px;
    }

    @media (max-width: 768px) {
        height: 400px;
    }

    @media (max-width: 600px) {
        height: 560px;
    }
`

export const Container = styled.div`
    margin: 0 auto;
    max-width: 1440px;
    padding: 0rem 2rem;
    width: 100%;

    @media (max-width: 430px) {
        padding: 0 1rem;
    }
`

export const MainContainer = styled.div`
    margin-left: 96px;
    width: 100%;
    @media (max-width: 1023px) {
    margin-left: 0px;
  }
`

export const HeaderText = styled.h1`
    font-size: 36px;
    line-height: 44px;
    font-weight: 600;
    color: #141f2f;
    margin-bottom: 1.5rem;
`

export const HoriLine = styled.hr`
    height: 3px;
    margin: 0.75rem auto;

`

export const AgentCardHolder = styled.div`
    display: grid;
    grid-template-columns: repeat(3,minmax(0,1fr));
    grid-row-gap: 25px;
        grid-column-gap: 25px;
    /* margin: 0 */

    @media (max-width: 1150px) {
        grid-template-columns: repeat(2,minmax(0,1fr));
        grid-row-gap: 25px;
        grid-column-gap: 25px;
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(1,minmax(0,1fr));
        grid-row-gap: 16px;
    }
`

export const ContentContainer = styled.div`
    // background-color: #EFF2F8;
    width: 100%;
    /* padding-top: 50px; */
    padding-bottom: 120px;
`

export const SectionHeader = styled.h2`
    font-size: 20px;
    font-weight: ${props => props.bold ? "600" : "500"};
    margin-bottom: 12px;
`